import logo from '../assets/syllabus_plus_logo.svg';
import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import "./CampRepDashboard.css";

const API_BASE = process.env.REACT_APP_API_URL || "http://localhost:5001/api";

const CampRepDashboard = () => {
  const [kind, setKind] = useState("");
  const [category, setCategory] = useState("");
  const [pendingItems, setPendingItems] = useState([]);
  const [verifiedCourses, setVerifiedCourses] = useState(0);
  const [verifiedResources, setVerifiedResources] = useState(0);
  const location = useLocation();

  useEffect(() => {
    fetch(`${API_BASE}/admin/dashboard`)
      .then((res) => res.json())
      .then((d) => {
        setVerifiedCourses(d.verifiedCourses ?? 0);
        setVerifiedResources(d.verifiedResources ?? 0);
      })
      .catch(() => {});
  }, [location.pathname]);

  useEffect(() => {
    const params = new URLSearchParams();
    if (kind) params.append("kind", kind);
    if (category) params.append("category", category);

    fetch(`${API_BASE}/admin/pending?${params.toString()}`)
      .then((res) => res.json())
      .then((data) => {
        const items = data.map((item) => ({
          ...item,
          to:
            item.kind === "Course"
              ? `/review-course/${item.courseId}`
              : `/review-resources/${item.courseId}`,
        }));
        setPendingItems(items);
      })
      .catch(() => setPendingItems([]));
  }, [kind, category, location.pathname]);

  return (
    <div className="campRepDash">
      <header className="campRepDashHeader">
        <Link to="/camp-rep-dashboard" className="logoStub"><img src={logo} alt="Syllabus+" height="32" /></Link>
        <Link to="/profile" className="profileStub" aria-label="profile">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="#0a0d18">
            <circle cx="12" cy="8" r="4" />
            <path d="M4 20c0-4 3.6-7 8-7s8 3 8 7" />
          </svg>
        </Link>
      </header>

      <main className="campRepDashMain">
        <p className="campRepDashEyebrow">CMP1001</p>
        <h1 className="campRepDashTitle">Dash board</h1>

        <div className="campRepFilters">
          <select className="campRepFilterBtn" value={kind} onChange={(e) => setKind(e.target.value)}>
            <option value="">Type</option>
            <option value="Course">Course</option>
            <option value="Resource">Resource</option>
          </select>
          <select className="campRepFilterBtn" value={category} onChange={(e) => setCategory(e.target.value)}>
            <option value="">Category</option>
            <option value="Notes">Notes</option>
            <option value="Practice Questions">Practice Questions</option>
            <option value="Flashcards">Flashcards</option>
            <option value="Videos">Videos</option>
            <option value="Computer Science">Computer Science</option>
            <option value="Mathematics">Mathematics</option>
            <option value="History">History</option>
            <option value="Physics">Physics</option>
          </select>
        </div>

        <div className="campRepStatsCard">
          <div className="campRepStatRow">
            <span className="campRepStatLabel">Verified Course</span>
            <span className="campRepStatValue">{verifiedCourses}</span>
          </div>
          <div className="campRepStatDivider" />
          <div className="campRepStatRow">
            <span className="campRepStatLabel">Verified Resources</span>
            <span className="campRepStatValue">{verifiedResources}</span>
          </div>
        </div>

        <div className="campRepReviewSection">
          <h2 className="campRepReviewTitle">Pending Review</h2>
          <div className="campRepReviewList">
            {pendingItems.map((item) => (
              <Link key={item.id} to={item.to} className="campRepReviewCard">
                <div className="campRepReviewCardTop">
                  <span className="campRepReviewKind">{item.kind}</span>
                  <span className="campRepPendingBadge">Pending</span>
                </div>
                <p className="campRepReviewName">{item.name}</p>
                <span className="campRepReviewCategory">{item.category}</span>
              </Link>
            ))}
          </div>
        </div>
      </main>
    </div>
  );
};

export default CampRepDashboard;
